var map = {
	"./advanced.svg": "4727",
	"./agile.svg": "cc62",
	"./arrow.svg": "21e2",
	"./big.svg": "3865",
	"./chat.svg": "9b69",
	"./compelling.svg": "79e8",
	"./contact.svg": "d015",
	"./empowering.svg": "2e5b",
	"./gear.svg": "f571",
	"./github-black.svg": "48fd",
	"./github.svg": "14f6",
	"./group.svg": "51a3",
	"./linkedin-black.svg": "7929",
	"./linkedin-grey.svg": "997b",
	"./linkedin.svg": "9ed9",
	"./marketsonics.svg": "b51d",
	"./ms-logo-dark.svg": "1f5b",
	"./ms-logo.svg": "5d73",
	"./practical.svg": "6f5e",
	"./reliable.svg": "a08a",
	"./scalable.svg": "978b",
	"./secured.svg": "926f",
	"./smile.svg": "0c16",
	"./success.svg": "1c27",
	"./target.svg": "0129",
	"./twitter-black.svg": "a03e",
	"./twitter-grey.svg": "8225",
	"./twitter.svg": "acf9",
	"./valuable.svg": "f14c",
	"./versatile.svg": "0efd",
	"./x.svg": "7387",
	"./youtube-black.svg": "d016",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";